module.exports = "/images/google-play-logo_sm.png?b517b15cf41b75ed4c1da05b7f8a4964";